import { useEffect, useState } from 'react';
import { timeLeft } from '../utils/format';

/** "9:05" left until `iso`, ticking every second; `expired` once it reaches zero. */
export function useCountdown(iso: string | null): { text: string; expired: boolean } {
  const [now, setNow] = useState(() => Date.now());
  const target = iso ? new Date(iso).getTime() : null;
  const running = target !== null && target > now;

  useEffect(() => {
    if (!running) return;
    const timer = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(timer);
  }, [running]);

  if (!iso || target === null) return { text: '', expired: false };
  return { text: timeLeft(iso, now), expired: target <= now };
}
